import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, DollarSign } from 'lucide-react';
import { CreateSplitPayTransactionForm } from '@/components/CreateSplitPayTransactionForm';

const CreateSplitPayTransactionPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/splitpay-transactions');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <Link to="/splitpay-transactions">
          <Button variant="outline" className="mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Transactions
          </Button>
        </Link>

        <div className="flex items-center space-x-3 mb-2">
          <DollarSign className="h-8 w-8 text-blue-600" />
          <h1 className="text-3xl font-bold text-gray-900">Create Split Pay Transaction</h1>
        </div>

        <p className="text-gray-600">
          Create a new split pay transaction by filling out the form below. All required fields must be completed.
        </p>
      </div>

      <CreateSplitPayTransactionForm onSuccess={handleSuccess} />
    </div>
  );
};

export default CreateSplitPayTransactionPage;
